import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { RTL } from 'src/app/@theme/const';
import { FieldDictionaryDto } from '../../models/base/base';
import { BaseService } from '../base/base.service';
import { SessionWrapperService } from '../session/session-wrapper.service';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import fonts from 'src/assets/fonts/pdf-font/Amiri';
// pdfMake.vfs = pdfFonts.pdfMake.vfs;
// pdfMake.vfs = fonts 
pdfMake.vfs = { ...pdfFonts.pdfMake.vfs, ...fonts };
pdfMake.fonts = {
  Amiri: {
    normal: 'Amiri-Regular.ttf',
    bold: 'Amiri-Bold.ttf'
  }
};

@Injectable({
  providedIn: 'root'
})
export class ExportService {
  currentlang
  constructor(private baseService: BaseService, private sessionService: SessionWrapperService, private themeLayout: ThemeLayoutService) {
    this.currentlang = this.baseService.getCurrentLanguage();
    this.themeLayout.directionChange.subscribe((dir) => {
      if (dir == RTL) {
        this.currentlang = 'ar'
      }
      else {
        this.currentlang = 'en'
      }
    })
  }

  exportexcel(data: any, displaylistfields, extradownloadproperties = null, filename = 'ExcelSheet'): void {
    let displayData = this.extractDisplayData(data, displaylistfields);
    let headerData = this.extractDisplayHeaders(displaylistfields);

    console.log('displayData', displayData, 'headerData', headerData);

    if (extradownloadproperties && extradownloadproperties?.length > 0) headerData = headerData.concat(extradownloadproperties);
    let heading = [];
    heading.push(headerData);
    /* pass here the table id */
    //let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(displayData); //table_to_sheet(this.gridDataList);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(ws, heading);

    //Starting in the second row to avoid overriding and skipping headers
    XLSX.utils.sheet_add_json(ws, displayData, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, filename + '-excel.xlsx');
  }

  exportCsv(data: any, displaylistfields: any, filename = 'myFile') {
    const displayData = this.extractDisplayData(data, displaylistfields);
    const headerData = this.extractDisplayHeaders(displaylistfields);

    const fields = Object.keys(displayData[0]);
    const csv = displayData.map((row: any) => fields.map((fieldname) => `"${row[fieldname]?.toString().replace(/"/g, '""')}"`).join(','));
    csv.unshift(headerData.join(',')); // Add header row
    const csvArray = csv.join('\r\n');

    // Add BOM for UTF-8 encoding
    const bom = '\uFEFF';
    const blob = new Blob([bom + csvArray], { type: 'text/csv;charset=utf-8;' });

    // Create a download link
    const a = document.createElement('a');
    const url = URL.createObjectURL(blob);
    a.href = url;
    a.download = `${filename}-csv.csv`;
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
    a.remove();
  }
  exportPdf(data: any[], displaylistfields, filename = 'pdfData') {
    console.log('pdfData', data, displaylistfields);
    let displayData = this.extractDisplayData(data, displaylistfields);
    let columnsArray = this.extractDisplayColumns(displaylistfields);

    // let DataArray = displayData.map((el, i) => {
    //   let elementArr = [];
    //   columnsArray.forEach((col) => elementArr.push(el[col]));
    //   return elementArr;
    // });

    // let DataArray = displayData.map((el) => {
    //   return columnsArray.map((col) => {
    //     let val = el[col];
    //     if (val === undefined || val === null) val = ''; // handle null/undefined
    //     return { text: String(val) }; // pdfMake يتعامل مع objects أفضل من raw strings
    //   });
    // });

    // let headersArray = this.extractDisplayHeaders(displaylistfields).map(el => this.currentlang === 'ar' ? this.convertTextToRtl(el) : el);

    // table body
    let DataArray = displayData.map((el) => {
      return columnsArray.map((col) => {
        let val = el[col];
        if (val === undefined || val === null) val = '';
        return {
          text: String(val),
          noWrap: true,
          alignment: this.currentlang === 'ar' ? 'right' : 'left'
        };
      });
    });

    //headers
    let headersArray = this.extractDisplayHeaders(displaylistfields).map(el => ({
      text: this.currentlang === 'ar' ? this.convertTextToRtl(el) : el,
      noWrap: true,
      alignment: this.currentlang === 'ar' ? 'right' : 'left',
      bold: true
    }));

    const allRows = [headersArray, ...DataArray];
    const columnsCount = headersArray.length; // تأكد إنها متطابقة مع كل صف في DataArray
    const dynamicWidths = new Array(columnsCount).fill('auto');
    console.log('dynamicWidths', dynamicWidths);

    // ✅ الشرط لتحديد حجم الصفحة
    const isWideTable = columnsCount > 6; // لو الأعمدة كتيرة
    const isLongText = headersArray.some(h => String(h).length > 20); // لو الهيدر طويل

    const pageSize = (isWideTable || isLongText) ? 'A3' : 'A4';
    const pageOrientation = (isWideTable || isLongText) ? 'landscape' : 'portrait';

    // debugger

    const tableBody = this.currentlang === 'ar'
      ? allRows.map(row => [...row].reverse()) // مهم تعمل spread قبل reverse عشان متأثرش على البيانات الأصلية
      : allRows;

    // debugger
    pdfMake
      .createPdf({
        header: {
          columns: [
            { text: this.setPDFHeader().username + ':' + this.setPDFHeader().currentdate, alignment: 'left' },
            {
              text: this.setPDFHeader().companyname, alignment: 'right'
            }
          ],
          style: 'header'
        },
        content: [
          { text: this.setPDFHeader().pagetitle, style: 'title' },
          {
            table: {
              widths: dynamicWidths,
              body: tableBody,
              //  dir: 'rtl'
            },
            style: 'table'
          }
        ],
        styles: {
          title: { fontSize: 18, bold: true, margin: [10, 20, 10, 10], alignment: 'center' },
          table: { margin: [40, 0, 10, 10] },
          header: { margin: [10, 10, 10, 10] }
        },
        pageOrientation: pageOrientation,
        pageSize: pageSize,
        defaultStyle: {
          font: 'Amiri', // Set the Arabic font as default
          alignment: this.currentlang === 'ar' ? 'right' : 'left',
        }
      })
      .download(filename + '-pdf');
  }

  extractDisplayData(data: any[], displaylistfields: FieldDictionaryDto[]) {
    let displayData = [];
    let columnsArray = this.extractDisplayColumns(displaylistfields);
    debugger
    displayData = data.map((data) => columnsArray.reduce((o, k) => ((o[k] = data[k]), o), {}));
    return displayData;
  }

  extractDisplayColumns(displaylistfields: FieldDictionaryDto[]) {
    const showGridData = displaylistfields?.filter((x) => x.fielddisplayon === 1);
    let columnsArray = showGridData?.sort((a, b) => (b.sort ?? 0) - (a.sort ?? 0)).map((x) => x.fieldname);
    return columnsArray;
  }

  extractDisplayHeaders(displaylistfields: FieldDictionaryDto[]) {
    const showGridHeaders = displaylistfields?.filter((x) => x.fielddisplayon === 1);
    let headersArray = showGridHeaders.sort((a, b) => (b.sort ?? 0) - (a.sort ?? 0)).map((x) => this.currentlang == 'ar' ? x.displayaraname : x.dislaylatname);
    return headersArray;
  }

  setPDFHeader() {
    const currentdate = new Date().toLocaleString();
    const username = this.sessionService.getUserName();
    const pagetitle = this.currentlang === 'ar' ? this.convertTextToRtl(this.sessionService.getPageTitle()) : this.sessionService.getPageTitle();
    const companyname = this.currentlang === 'ar' ? this.convertTextToRtl(this.sessionService.getCompanyName()) : this.sessionService.getCompanyName();
    return { username, currentdate, pagetitle, companyname }
  }

  convertTextToRtl(text) { return text.split(" ").reverse().join(" "); }


}
